import angular from 'angular';

class homeCtrl {
    /* @ngInject */
    constructor(AppSvc, GED_COMPONENTS, LIFECYCLE_STATUS) {
        this.AppSvc = AppSvc;
        this.GED_COMPONENTS = GED_COMPONENTS;
        this.LIFECYCLE_STATUS = LIFECYCLE_STATUS;
        // Infos des applications
        var naResult = {version: 'N/A', buildTime: 'N/A', url: null};
        this.applicationInfo = {
            kiss_fo: Object.assign({}, naResult, {title: 'Portail SY'}),
            kiss_bo: Object.assign({}, naResult, {title: 'Back-office SY'}),
            epdf: Object.assign({}, naResult, {title: 'ePDF'}),
            zedoc: Object.assign({}, naResult, {title: 'ZeDoc'}),
            pre_pasrel: Object.assign({}, naResult, {title: 'Pasrel : Pré-traitement fournisseur SY'}),
            pasrel_emre: Object.assign({}, naResult, {title: 'Pasrel : moteur de dématérialisation'}),
            pasrel_metiers: Object.assign({}, naResult, {title: 'Pasrel : portail'}),
            business_control_core: Object.assign({}, naResult, {title: 'Core brique de contrôle'}),
            business_control_std: Object.assign({}, naResult, {title: 'Standard brique de contrôle'}),
            doc_repo: Object.assign({}, naResult, {title: 'DocRepo'}),
            workflow: Object.assign({}, naResult, {title: 'Workflow'}),
            gis: Object.assign({}, naResult, {title: 'Gis'}),
            gedBackEnd: Object.assign({}, naResult, {title: 'Ged BO'}),
            gedFrontEnd: Object.assign({}, naResult, {title: 'Ged UI'}),
            einvoicing: Object.assign({}, naResult, {title: 'E-Invoicing'}),
            lifecycle_external: Object.assign({}, naResult, {title: 'LifeCycle : Réception fichier PDP'}),
            lifecycle_docrepo: Object.assign({}, naResult, {title: 'LifeCycle : Mise à jour DocRepo'}),
            lifecycle_dispatch: Object.assign({}, naResult, {title: 'LifeCycle : Dispatch des events DocRepo'}),
            lifecycle_sender: Object.assign({}, naResult, {title: 'LifeCycle : Envoi PDP/PPF'}),
        };

        this.components = Object.values(this.applicationInfo);
    }

    $onInit() {
        var errorCallback = () => {
            /* Do nothing : on reste avec l'information N/A */
        };
        // Récupération de la version de Kiss Front Office
        this.AppSvc.getKissFOVersion().then(versionFile => {
            Object.assign(this.applicationInfo.kiss_fo, versionFile.data);
        }, errorCallback);
        // Récupération de la version de Kiss BackOffice
        this.AppSvc.getKissBOVersion().then(versionFile => {
            Object.assign(this.applicationInfo.kiss_bo, versionFile.data);
        }, errorCallback);
        // Récupération de la version de ePdf
        this.AppSvc.getEpdfVersion().then(versionFile => {
            Object.assign(this.applicationInfo.epdf, versionFile.data);
        }, errorCallback);
        // Récupération de la version de ZeDoc
        this.AppSvc.getZedocVersion().then(versionFile => {
            Object.assign(this.applicationInfo.zedoc, versionFile.data);
        }, errorCallback);
        // Récupération de la version de pre-traitement Pasrel
        this.AppSvc.getPrePasrelVersion().then(versionFile => {
            Object.assign(this.applicationInfo.pre_pasrel, versionFile.data);
        }, errorCallback);
        // Récupération de la version de Pasrel EMRE
        this.AppSvc.getPasrelEmreVersion().then(versionFile => {
            Object.assign(this.applicationInfo.pasrel_emre, versionFile.data);
        }, errorCallback);
        // Récupération de la version de Pasrel METIERS
        this.AppSvc.getPasrelMetiersVersion().then(versionFile => {
            Object.assign(this.applicationInfo.pasrel_metiers, versionFile.data);
        }, errorCallback);
        // Récupération de la version de business Control
        this.AppSvc.getBusinessControlVersion().then(versionFile => {
            Object.assign(this.applicationInfo.business_control_core, {
                version: versionFile.data.VERSION_CORE,
                buildTime: versionFile.data.DATE_MODIFICATION_CORE,
            });
            Object.assign(this.applicationInfo.business_control_std, {
                version: versionFile.data.VERSION_STANDARD,
                buildTime: versionFile.data.DATE_MODIFICATION_STANDARD,
            });
        }, errorCallback);
        // Récupération de la version de la DocRepo
        this.AppSvc.getDocRepoVersion().then(versionFile => {
            Object.assign(this.applicationInfo.doc_repo, versionFile.data);
        }, errorCallback);
        // Récupération des versions de la Ged
        this.AppSvc.getGedVersion().then(versionFile => {
            Object.assign(this.applicationInfo.gedBackEnd, (Array.from(versionFile.data)).find(entry => entry.component === angular.copy(this.GED_COMPONENTS.BACKEND)));
            Object.assign(this.applicationInfo.gedFrontEnd, (Array.from(versionFile.data)).find(entry => entry.component === angular.copy(this.GED_COMPONENTS.FRONTEND)));
        }, errorCallback);
        // Récupération de la version de Gis
        this.AppSvc.getGisVersion().then(versionFile => {
            Object.assign(this.applicationInfo.gis, {
                version: versionFile.data.version,
                buildTime: versionFile.data.buildTime,
            });
        }, errorCallback());
        // Récupération de la version E-Invoicing
        this.AppSvc.getEInvoicingVersion().then(versionFile => {
            Object.assign(this.applicationInfo.einvoicing, {
                version: versionFile.data.version,
                buildTime: versionFile.data.buildTime,
            });
        }, errorCallback());
        // Récupération de la version LifeCycle
        const lifeCycleStatus = new Map([[this.LIFECYCLE_STATUS.EXTERNAL, this.applicationInfo.lifecycle_external],
            [this.LIFECYCLE_STATUS.DOCREPO, this.applicationInfo.lifecycle_docrepo],
            [this.LIFECYCLE_STATUS.DISPATCH, this.applicationInfo.lifecycle_dispatch],
            [this.LIFECYCLE_STATUS.SENDER, this.applicationInfo.lifecycle_sender]]);
        lifeCycleStatus.forEach((value, key) =>
            this.AppSvc.getLifeCycleVersion(key).then(({data: {version, buildTime}}) => {
                Object.assign(value, {
                    version,
                    buildTime,
                });
            }, errorCallback()));
        // Récuperation des urls des composants
        this.applicationInfo.kiss_fo.url = this.componentsUrls.data.syFoUrl;
        this.applicationInfo.doc_repo.url = this.componentsUrls.data.docRepoUrl;
        this.applicationInfo.zedoc.url = this.componentsUrls.data.zedocUrl;
        this.applicationInfo.workflow.url = this.componentsUrls.data.workflowUrl;
        this.applicationInfo.pasrel_metiers.url = this.componentsUrls.data.pasrelUrl;
        this.applicationInfo.gis.url = this.componentsUrls.data.gisBoUrl;
        this.applicationInfo.business_control_core.url = this.componentsUrls.data.businessControlUrl;
        this.applicationInfo.gedBackEnd.url = this.componentsUrls.data.gedUrl;
    }
}

angular.module('app.home').component('home', {
    templateUrl: require('./home.html'),
    controller: homeCtrl,
    bindings: {
        componentsUrls: '<',
    },
});
